
window.IMAGE_UTILS = (() => {
  /**
   * Attmpts to create a cloudinary url with the given width and height
   * @param {string} imageUrl 
   * @param {object} param1 - object with cloudinary options like width and height
   * @returns {string} - cloudinary url with the given width and height if possible, else returns the original url
   */
  const  normalizeUrl = (imageUrl, { width = '800', height = '800' } = {}) => {
    // Cloudinary options
    const options = ['c_fit', `w_${width}`, `h_${height}`, 'f_auto'].join(',');
    if (!imageUrl) return imageUrl;
    if (imageUrl.includes('/upload/v')) {
      const resizedPhoto = imageUrl.replace(
        /upload\//g,
        `upload/${options}/`
      );
      return resizedPhoto;
    } else {
      return imageUrl;
    }
  }
  
  /**
   * Adds image load error handling for broken image urls
   * @param {HTMLAnchorElement} imageElement - element to add error handling to
   * @param {string} imageErrorAltText - alt text for the element
   */
  const fallbackToCameraShyImage = (imageElement, imageErrorAltText) => {
    const onImageError = () => {
      imageElement.src = localStorage.getItem('cameraShyImageUrl');
      imageElement.alt = imageErrorAltText;
      imageElement.removeEventListener('error', onImageError);
    };
    imageElement.addEventListener('error', onImageError);
  };

  /**
   * Assigns an image src to provided element
   * @param {object} param0
   * @param {string} param0.imgUrl - image url
   * @param {HTMLAnchorElement} param0.imageElement - element to assign the image to
   * @param {object} param0.imgOptions - object with cloudinary options like width and height
   * @param {string} param0.altText - alt text for the img element
   */
  const setElementImage = ({imgUrl, imageElement, imgOptions, altText}) => {
    if (imageElement.nodeName !== 'IMG') {
      throw new Error('Element must be an image');
    } else {
      const { altErrorImageMessage } = window?.altCameraShyMessage;
      if (imgUrl) {
        imageElement.src = normalizeUrl(imgUrl, imgOptions);
        imageElement.alt = altText;
      } else {
        imageElement.src = localStorage.getItem('cameraShyImageUrl');
        imageElement.alt = altErrorImageMessage;
      }
      fallbackToCameraShyImage(imageElement, altErrorImageMessage);
    }
  }

  return {
    setElementImage,
  }
})();